// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const pignite: PokeData = {
  "id": 499,
  "name": "pignite",
  "height": 10,
  "weight": 555,
  "base_experience": 146,
  "types": [
    PokeType.FIRE,
    PokeType.FIGHTING
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "tail-whip",
    "roar",
    "ember",
    "flamethrower",
    "defense-curl",
    "smog",
    "endure",
    "rollout",
    "arm-thrust",
    "odor-sleuth",
    "assurance",
    "flare-blitz",
    "head-smash",
    "flame-charge",
    "heat-crash"
  ],
  "moves": [
    "tackle",
    "ember",
    "flamethrower",
    "flare-blitz",
    "close-combat",
    "meteor-assault",
    "fire-fang",
    "bulk-up",
    "vacuum-wave",
    "superpower",
    "double-kick",
    "eruption",
    "coaching"
  ],
  "evolution_chain": {
    "id": 257,
    "item": null,
    "species": [
      {
        "name": "tepig",
        "order": 499,
        "types": [
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "pignite",
        "order": 500,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 498,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 17,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "emboar",
        "order": 501,
        "types": [
          PokeType.FIRE,
          PokeType.FIGHTING
        ],
        "evolves_from_species_id": 499,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 36,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 72.5,
    "speed": 55,
    "ability_power": 93
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
